export enum SensorTabType {
  SENSORS = "sensors",
  GATEWAYS = "gateways",
  ARCHIVED = "archived",
  ALERTS = "alerts",
}

export const sensorTabMapToIndex: Record<SensorTabType, number> = {
  [SensorTabType.SENSORS]: 0,
  [SensorTabType.GATEWAYS]: 1,
  [SensorTabType.ALERTS]: 2,
  [SensorTabType.ARCHIVED]: 3,
};

export const sensorTabToDisplayName: Record<SensorTabType, string> = {
  [SensorTabType.SENSORS]: "Sensors",
  [SensorTabType.GATEWAYS]: "Gateways",
  [SensorTabType.ARCHIVED]: "Archived",
  [SensorTabType.ALERTS]: "Alerts",
};

export const sensorTabList: SensorTabType[] = Object.keys(
  sensorTabMapToIndex,
) as SensorTabType[];

export const getTabIndex = (tabType: SensorTabType): number => {
  return sensorTabMapToIndex[tabType];
};
const sensorIndexToTab = () => {
  const remappedEntries = Object.entries(sensorTabMapToIndex).map(
    ([key, value]) => [value, key],
  );

  return Object.fromEntries(remappedEntries);
};

export const SensorIndexToTab: Record<number, SensorTabType> =
  sensorIndexToTab();

// Route segment for each tab. Sensors is the default tab, so it has no
// segment of its own - "/sensors" alone renders it.
export const sensorTabToRouteSlug: Record<SensorTabType, string> = {
  [SensorTabType.SENSORS]: "",
  [SensorTabType.GATEWAYS]: "gateways",
  [SensorTabType.ARCHIVED]: "archive",
  [SensorTabType.ALERTS]: "alerts",
};

export const routeSlugToSensorTab = (
  slug: string | undefined,
): SensorTabType => {
  const found = Object.entries(sensorTabToRouteSlug).find(
    ([, tabSlug]) => tabSlug === slug,
  );
  return (found?.[0] as SensorTabType) ?? SensorTabType.SENSORS;
};
